<template>
    <gofix-card title="Workers" fullContent classContent="mb-0">
        <gofix-table 
            class="noFullHeight scrollAbsolute"
            :settings="tableConfig"
            :table-items="tableItems"
            @new-item="newItem"
            @row-click="handleClickRow"
            @delete-items="deleteItems"
            @load-items="getTableData"
            ref="gofixTable">
            <template slot="gofix_table:signature_attendance" slot-scope="row">
                <template v-if="row.item.safety_joblist_worker && row.item.safety_joblist_worker.signature_attendance && row.item.safety_joblist_worker.signature_attendance.length">
                    <gofix-text-field label=" " class="photosThumb mt-2">
                        <viewer-image :images="row.item.safety_joblist_worker.signature_attendance">
                            <template slot="gofixViewer:list_image" ref="viewerFinding" slot-scope="{images}">
                                <div v-for="(item_image, key) in images">
                                    <img v-auth-image="item_image.url.original" :alt="item_image.image_file_name" :key="item_image.url.original" src="img/loading.gif" width="150" class="mr-2">
                                </div>
                            </template>
                        </viewer-image>
                    </gofix-text-field>
                </template>
            </template>
        </gofix-table>

        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            :title="modals.add.data.id ? 'Edit Worker' : 'Add Workers'" 
            hide-footer 
            :centered="true" 
            v-model="modals.add.open">
            <template>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-input-number 
                            v-if="modals.add.data.id"
                            label="Temparature" 
                            v-model="modals.add.data.temperature" 
                            :integer-limit="2" 
                            :include-thousands-separator="false" 
                            :rows="5"
                            :allowDecimal="true" class="gofixInputNoMinWidth">
                        </gofix-form-input-number>
                        <gofix-form-dropdown
                            v-if="!modals.add.data.id"
                            label="Workers"
                            vLabel="user_name"
                            class="mb-3"
                            @search="searchWorker"
                            :filterable="false"
                            :required="!modals.add.data.is_new_worker"
                            :show-icon-required="!modals.add.data.is_new_worker"
                            :disabled="modals.add.data.is_new_worker"
                            multiple
                            :reduce="option => option.id"
                            v-model="modals.add.data.safety_worker_ids"
                            :options="modals.add.options.workers">
                            <template slot="gofixInput:dropdown:option"  slot-scope="option">
                                {{option.name}} - {{option.ic_fin}}
                            </template>
                            <template slot="gofixInput:dropdown:selected-option"  slot-scope="option">
                                {{option.name}} - {{option.ic_fin}}
                            </template>
                        </gofix-form-dropdown>
                        <template v-if="!modals.add.data.id">
                            <div class="d-flex">
                                <b-form-checkbox v-model="modals.add.data.is_new_worker" class="checkbox-main-allow mt-0">
                                    <span>Allow a new Worker</span>
                                </b-form-checkbox>
                            </div>
                            <div class="mt-3" v-if="modals.add.data.is_new_worker">
                                <gofix-form-input 
                                    label="Name" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.name">
                                </gofix-form-input>
                                <gofix-form-input 
                                    label="IC/FIN" 
                                    required
                                    show-icon-required
                                    v-model="modals.add.data.ic_fin">
                                </gofix-form-input>
                                <!-- <gofix-form-input 
                                    label="Department" 
                                    v-model="modals.add.data.department">
                                </gofix-form-input> -->
                                <gofix-form-dropdown 
                                    label="Company" 
                                    vLabel="name"
                                    required
                                    show-icon-required
                                    appendToBody
                                    :filterable="false"
                                    @search="searchCompanies"
                                    v-model="modals.add.data.company" 
                                    :options="modals.add.options.companies">
                                </gofix-form-dropdown>
                                <gofix-form-input-date
                                    show-icon-required
                                    required
                                    :minDate="new Date()" 
                                    v-model="modals.add.data.expiry_date"
                                    label="Work Permit Expiry">
                                </gofix-form-input-date>
                            </div>
                        </template>
                    </b-col>
                </b-row> 
            </template>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="save" :disabled="modals.add.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>

<script>
import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'
const ViewerImage = () => import('@/views/plugins/ViewerImage.vue')
import moment from 'moment';

export default {
    name: 'safety-workers-listing',
    components: {
        ViewerImage
    },
    data() {
        let filter = JSON.parse(JSON.stringify(filters['safety_workers_listing']));
        return {
            tableConfig:{
                name: 'safety-workers-listing-2',
                controls:{
                    create: this.$checkRole(this.$accessModule.toolbox_meeting, 'update'),
                    delete: this.$checkRole(this.$accessModule.toolbox_meeting, 'update'),
                    tableImport: false,
                    tableExport: false,
                },
                filter: filter,
                page: 1,
                limit: 100,
                total: 0,
                sortColumn: "id",
                sortDirection: "asc",
                dataSelect: {
                    status: {
                        value: [
                            {value: 'New', text: 'New'},
                            {value: 'Attended', text: 'Attended'}
                        ],
                        value_field: 'value',
                        text_field: 'text'
                    }
                },
                fields: [
                    {
                        key: 'actions',
                        label: '',
                        thClass: 'checkbox-column text-center',
                        tdClass: 'checkbox-column text-center',
                        width: 50,
                        thStyle: "width:50px",
                    },
                    {
                        key: 'safety_worker_id',
                        label: 'ID',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:100px",
                        sorting: true,
                        with:350
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:200px",
                        sorting: true,
                        with:350
                    },
                    {
                        key: 'ic_fin',
                        label: 'IC/FIN',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:200px",
                        sorting: true,
                        with:350
                    },
                    {
                        key: 'company',
                        label: 'Company',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:200px",
                        sorting: true,
                        with:350
                    },
                    {
                        key: 'temperature',
                        label: 'Temperature',
                        isActive: 1,
                        isFilter: true,
                        thStyle: "width:200px",
                        sorting: true,
                        with:350
                    },
                    {
                        key: 'signature_attendance',
                        label: 'Signature',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:200px",
                        sorting: false,
                        with:500
                    },
                    // {
                    //     key: 'status',
                    //     label: 'Status',
                    //     isActive: 1,
                    //     isFilter: true,
                    //     thStyle: "width:auto",
                    //     sorting: true,
                    //     with:null
                    // }
                ],
            },
            tableItems: [],
            modals: {
                add: {
                    open: false,
                    loading: false,
                    data: {
                        id: null,
                        safety_job_id: null,
                        safety_worker_ids: null,
                        safety_worker_id: null,
                        is_new_worker: false,
                        name: null,
                        ic_fin: null,
                        // department: null,
                        expiry_date: null,
                        company: null,
                        temperature: null,
                    },
                    options: {
                        workers: [],
                        scontracts: [],
                        topics: [],
                        companies: [],
                    }
                }
            },
            timer: {
                scontracts: null,
                workers: null,
                save: null
            },
        }
    },
    computed: {
        ...mapGetters({
            Item: 'SafetyAppController/safetyJob',
        }),
    },
    watch: {
        "modals.add.data.is_new_worker": function(val) {
            if(val) {
                this.modals.add.data.safety_worker_id = null;
                this.modals.add.data.safety_worker_ids = null;
                this.modals.add.data.name = null;
                this.modals.add.data.ic_fin = null;
                // this.modals.add.data.department = null;
                this.modals.add.data.expiry_date = null;
                this.modals.add.data.temperature = null;
            }
        },
        Item: function(val) {
            this.updateAdd();
        }
    },
    methods: {
        async getTableData(callback) {
            // Handle loading table data
            try {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.safety_job_id = this.$route.params.id
                await this.$store.dispatch("SafetyAppController/getworkerItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load list of attendees", "danger");
                        reject();
                    })
            } catch (error) {
                console.error('Error fetching table data:', error)
            }
        },
        async updateAdd () {
            if(this.Item && this.Item.id) {
                this.tableConfig.controls.create = this.$checkRole(this.$accessModule.toolbox_meeting, 'update');
                this.tableConfig.controls.delete = this.$checkRole(this.$accessModule.toolbox_meeting, 'update');
                if(this.Item.status && !['New'].includes(this.Item.status)) {
                    this.tableConfig.controls.create = false;
                    this.tableConfig.controls.delete = false;
                }

                this.$nextTick(() => {
                    if(this.$refs['gofixTable']) this.$refs['gofixTable'].updateCreateBT()
                    if(this.$refs['gofixTable']) this.$refs['gofixTable'].updateDeletedBT()
                });
            }
            
        },
        handleClickRow(item) {
            this.modals.add.data = Object.assign(this.modals.add.data, {
                id: item.id,
                safety_job_id: item.safety_job_id,
                safety_worker_ids: null,
                safety_worker_id: item.safety_worker_id,
                temperature: item.temperature,
            });
            this.getCompanies()
            this.modals.add.open = true;
        },
        newItem() {
            this.modals.add.data = Object.assign(this.modals.add.data, {
                id: null,
                safety_job_id: this.Item.id,
                safety_worker_ids: null,
                safety_worker_id: null,
                temperature: null,
                company: this.Item.supplier_id ? {id: this.Item.supplier_id, name: this.Item.supplier} : null,
            });
            this.getWorkers()
            this.getCompanies()
            this.modals.add.open = true;
        },
        async deleteItems(callback){
            const { ids,filter, resolve,reject } = await callback();
            this.$store.dispatch("SafetyAppController/deleteWorkerForToolboxMeetingItem", ids)
            .then(response => {
                resolve(this.$notificationV2('deleting', 'safety_worker'));
            })
            .catch(err =>{
                reject(err);
            });
        },
        exportItems() {
            // Handle exporting items
            // Implement export logic (e.g., to CSV, PDF, etc.)
        },

        async getWorkers(search = '') {
            let tableRequest = {
                filter: { 
                    search: search,
                    company_id: this.Item.supplier_id
                },
                page: 1,
                limit: 100
            }

            await this.$store.dispatch("SafetyAppController/getworkerItems", tableRequest)
                .then(response => {
                    this.modals.add.options.workers = response.items;
                })
                .catch(err => {})
        },
        async searchWorker(search, loading) {
            loading(true)
            this.modals.add.options.workers = []
            if (this.timer.workers) {
                clearTimeout(this.timer.workers);
                this.timer.workers = null;
            }
            this.timer.workers = setTimeout(async () => {
                try {
                    await this.getWorkers(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        save() {
            if (this.timer.save) {
                clearTimeout(this.timer.save);
                this.timer.save = null;
            }
            this.timer.save = setTimeout(async () => {

                if(!this.modals.add.data.id) {
                    if(this.modals.add.data.is_new_worker) {
                        const validate_fields = [
                            { key: 'name', name: 'Name'},
                            { key: 'ic_fin', name: 'IC/FIN'},
                            { key: 'company', name: 'Company'},
                            { key: 'expiry_date', name: 'Work Permit Expiry'},
                        ]
                        const is_validate = this.$validationData(validate_fields, this.modals.add.data)
                        if(is_validate) return
                    } else {
                        if((!this.modals.add.data.safety_worker_ids || !this.modals.add.data.safety_worker_ids.length)) {
                            return this.$alertNotification("Please choose a worker.", "danger");
                        }
                    }
                }

                if(this.modals.add.loading) return;
                this.modals.add.loading = true;

                let params = {
                    safety_job_id: this.modals.add.data.safety_job_id,
                }

                if(this.modals.add.data.id) {
                    params.id = this.modals.add.data.id
                    params.safety_worker_id = this.modals.add.data.safety_worker_id
                    params.temperature = Number(this.modals.add.data.temperature)
                } else {
                    if(this.modals.add.data.is_new_worker) {
                        params.is_new_worker = true
                        params.name = this.modals.add.data.name
                        params.ic_fin = this.modals.add.data.ic_fin
                        // params.department = this.modals.add.data.department
                        params.expiry_date = this.modals.add.data.expiry_date ? moment(this.modals.add.data.expiry_date).format('YYYY-MM-DD') : null
                        params.company_id = this.modals.add.data.company ? this.modals.add.data.company.id : null
                        params.company = this.modals.add.data.company ? this.modals.add.data.company.name : null
                    } else {
                        params.safety_worker_ids =this.modals.add.data.safety_worker_ids
                    }
                }

                let api = 'createWorkerForToolboxMeetingItem'
                if(this.modals.add.data.id) {
                    api = 'updateWorkerForToolboxMeetingItem'
                }
                
                this.$store.dispatch(`SafetyAppController/${api}`, params)
                .then(async response => {
                    this.modals.add.loading = false;
                    if(response.code && response.message) {
                        this.$alertNotification(response.message, "danger");
                        return;
                    }
                    this.modals.add.open = false;
                    this.$alertNotification(this.$notificationV2('adding', 'safety_worker'), "success");
                    this.$refs.gofixTable.reloadTableItems();
                })
                .catch(err => {
                    this.modals.add.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })

            }, 200);
        },
        async getCompanies(search = '') {
            let tableRequest = {
                page: 1, 
                isCMS: 1,
                filter: { 
                    name: { type: "text", value: search, function: "ilike", with: [] },
                    is_supplier: { type: 'boolean', value: true },
                    is_safety: { type: 'boolean', value: true },
                }, 
                limit: 100
            }

            await this.$store.dispatch("OrganizationController/getItemsNoCommit", tableRequest)
                .then(response => {
                    this.modals.add.options.companies = response.data.data.items;
                })
                .catch(err => {})
        },
        async searchCompanies(search, loading) {
            loading(true)
            this.modals.add.options.companies = []
            if (this.timer.companies) {
                clearTimeout(this.timer.companies);
                this.timer.companies = null;
            }
            this.timer.companies = setTimeout(async () => {
                try {
                    await this.getCompanies(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
    },
    created() {
        this.updateAdd();
    }
}
</script>